{
  "pending": "Pending",
  "delivered": "Delivered",
  "retry": "Retry",
  "error": "In error",
  "cancelling": "Cancelling",
  "cancelled": "Cancelled",
  "paused": "Paused",
  "done": "Done",
  "running": "Running",
  "expired": "Expired",
  "dateFormat": "YYYY/MM/DD [at] hh:mm A",
  "operationType": {
    "CRTCLT_RENEWAL_DVC": "Certificate renewal",
    "CRTCLT_RENEWAL_APP": "Certificate renewal",
    "FIRMWARE_UPGRADE_DVC": "Firmware upgrade"
  },
  "type": "Operation type",
  "createdAt": "Created at",
  "launchedAt": "Planned launch date",
  "updatedAt": "Updated at",
  "state": "Operation status",
  "certificate": {
    "update": {
      "label": "Certificate renewal",
      "dateTimeError": "A datetime is required for updating certificate",
      "plannedStartAt": {
        "label": "Configure the operation",
        "placeholder": "Select an update date"
      },
      "dateNotValidAfterRenewal": "The date must be valid before the certificate expiration"
    }
  },
  "firmware": {
    "update": {
      "label": "Update firmware",
      "description": "Date and time parameters are required to launch the update of the {name} firmware",
      "firmwareLabel": "Firmware",
      "uuidRequired": "The firmware is required",
      "plannedStartAt": "Datetime of firmware update (YYYY/MM/DD HH:MM)",
      "notaBene": "The update of the firwmare will be carried out during the next communication with the {name} from the update date time of the firmware.",
      "dateTimeError": "A datetime is required for updating firmware",
      "warningMessage": "Warning: Updating the firmware will induce a reboot of the related device at the end of the update.",
      "version": "Version",
      "dtwin": {
        "description": "Configure the firmware update operation.",
        "launchPlannedAt": "Update date",
        "validation": {
          "launchPlannedAt": "The update date is required."
        },
        "startsAtCreation": "Operation transmission to the device as soon as possible",
        "firmware": "Select a firmware in the list below"
      },
      "scheduled": {
        "warningMessage": "The device already have a scheduled, pending or running operation of the same type"
      }
    }
  },
  "dateInferiorToToday": "The date must not be smaller than today's date/time",
  "empty": "No operations found",
  "actions": "Actions",
  "queued": "Queued",
  "failed": "Failed",
  "unknown": "Unknown status",
  "scheduled": "Scheduled",
  "configuration": {
    "selfSupportingVersion": "Self-supporting version",
    "globalVersion": "Global version",
    "specificVersion": "Specific version",
    "updatedDate": "Updated date"
  },
  "unitary": {
    "title": "Unitary"
  },
  "campaign": {
    "title": "Campaign"
  },
  "trigger": {
    "title": "Trigger",
    "AUTO": "Automatic",
    "MANUAL": "Manual"
  },
  "on_hold": "On hold"
}
